import Templates from '@/templates'
import Login from 'components/auth/login'
import Logout from 'components/auth/logout'
import ForgotPassword from 'components/auth/forgot'
import Reset from 'components/auth/reset'
import NotFound from 'components/404'
import Dashboards from 'components/dashboards'
import Clients from 'components/clients'
import Applications from 'components/applications'
import Environments from 'components/environments'
import FinancialTargets from 'components/financial-targets'
import Clusters from 'components/clusters'
import Slas from 'components/slas'
import Support from 'components/support'
import Quotes from 'components/quotes'
import SprintReviews from 'components/sprint-reviews'
import Schedule from 'components/schedule'
import ProjectsPlanner from 'components/projects-planner'
import Warranties from 'components/warranties'
import Budgets from 'components/budgets'
import Leads from 'components/leads'
import settingsRoutes from './routes/settings'
import projectsRoutes from './routes/projects'
import opportunitiesRoutes from './routes/opportunities'
import signOffsRoutes from './routes/sign-offs'
import supportRoutes from './routes/support'
import userRoutes from './routes/users'
import invoiceRoutes from './routes/invoices'
import stackRoutes from './routes/stacks'
import retainerRoutes from './routes/retainers'
import projectCalculationRoutes from './routes/project-calculations'
import forecastRoutes from './routes/forecast'
import aiRoutes from './routes/ai'

export default [
	{
		path: '/auth',
        component: Templates.Auth,
        children: [
            {
            	path: 'login',
                name: 'auth.login',
                component: Login,
                guest: true,
                alias: '/auth',
                meta: { bodyClass: 'login' }
            },
            {
            	path: 'logout',
                name: 'auth.logout',
                component: Logout,
                auth: true,
                meta: { requiresAuth: true },
            },
            {
            	path: 'forgot',
              	component: ForgotPassword,
                  guest: true,
                  meta: { bodyClass: 'login' }
            },
            {
            	path: 'reset',
              	component: Reset,
                guest: true,
                meta: { bodyClass: 'login' }
            }
        ]
    },
    {
        path: '/dashboard/projects',
        component: Dashboards.Projects,
        name: 'dashboards.projects',
        alias: '/dashboard',
        meta: { template: 'chameleon', requiresAuth: true }
    },
    {
        path: '/dashboard/utilization',
        component: Dashboards.Utilization,
        name: 'dashboards.utilization',
        meta: { template: 'chameleon', requiresAuth: true }
    },
    {
        path: '/dashboard/financial',
        component: Dashboards.Financial,
        name: 'dashboards.financial',
        meta: { template: 'chameleon', requiresAuth: true }
    },
    {
        path: '/dashboard/sales',
        component: Dashboards.Sales,
        name: 'dashboards.sales',
        meta: { template: 'chameleon', requiresAuth: true }
    },
    ...supportRoutes,
    ...userRoutes,
    ...settingsRoutes,
    ...opportunitiesRoutes,
    ...signOffsRoutes,
    ...stackRoutes,
    ...retainerRoutes,
    ...projectCalculationRoutes,
    ...forecastRoutes,
    ...invoiceRoutes,
    ...aiRoutes,
    ...projectsRoutes,
    {
        path: '/clients',
        component: Clients.Clients,
        name: 'clients.index',
        meta: { template: 'chameleon', requiresAuth: true }
    },
    {
        path: '/clients/:client_id',
        component: Clients.Show,
        name: 'clients.show',
        props: true,
        meta: { template: 'chameleon', requiresAuth: true },
        children: [
            {
                path: 'timeline',
                component: Clients.Timeline,
                name: 'clients.timeline',
                meta: { template: 'chameleon', requiresAuth: true }
            },
            {
                path: 'details',
                component: Clients.Details,
                name: 'clients.details',
                meta: { template: 'chameleon', requiresAuth: true }
            },
            {
                path: 'contacts',
                component: Clients.Contacts,
                name: 'clients.contacts',
                meta: { template: 'chameleon', requiresAuth: true }
            }
        ]
    },
    {
      path: '/slas',
        component: Slas.Slas,
        name: 'slas.index',
        meta: { template: 'chameleon', requiresAuth: true }
    },
    {
        path: '/slas/:sla_id',
        component: Slas.Show,
        name: 'slas.show',
        meta: { template: 'chameleon', requiresAuth: true }
    },
    {
      path: '/projects-planner',
        component: ProjectsPlanner.ProjectsPlanner,
        name: 'projects.planner.index',
        meta: { template: 'chameleon', requiresAuth: true }
    },
    {
        path: '/warranties',
        component: Warranties.WarrantiesList,
        name: 'warranties.index',
        meta: { template: 'chameleon', requiresAuth: true }
    },
    {
        path: '/applications',
        component: Applications.Applications,
        name: 'applications.index',
        meta: { template: 'chameleon', requiresAuth: true }
    },
    {
        path: '/applications/:application_id',
        component: Applications.Show,
        name: 'applications.show',
        meta: { template: 'chameleon', requiresAuth: true }
    },
    {
        path: '/clusters',
        component: Clusters.Clusters,
        name: 'clusters.index',
        meta: { template: 'chameleon', requiresAuth: true }
    },
    {
        path: '/clusters/:cluster_id',
        component: Clusters.Show,
        name: 'clusters.show',
        meta: { template: 'chameleon', requiresAuth: true }
    },
    {
        path: '/financial-targets',
        component: FinancialTargets.FinancialTargets,
        name: 'financial-targets.index',
        meta: { template: 'chameleon', requiresAuth: true }
    },
    {
        path: '/financial-targets/:financial_target_id',
        component: FinancialTargets.Show,
        name: 'financial-targets.show',
        meta: { template: 'chameleon', requiresAuth: true }
    },
    {
        path: '/budgets',
        component: Budgets.Budgets,
        name: 'budgets.index',
        meta: { template: 'chameleon', requiresAuth: true }
    },
    {
        path: '/budgets/:budget_id',
        component: Budgets.Show,
        name: 'budgets.show',
        meta: { template: 'chameleon', requiresAuth: true },
        children: [
            {
                path: 'overview',
                component: Budgets.Overview,
                name: 'budgets.overview',
                meta: { template: 'chameleon', requiresAuth: true }
            },
            {
                path: 'billing',
                component: Budgets.Billing,
                name: 'budgets.billing',
                meta: { template: 'chameleon', requiresAuth: true }
            },
            {
                path: 'panda',
                component: Budgets.Panda,
                name: 'budgets.panda',
                meta: { template: 'chameleon', requiresAuth: true }
            }
        ]
    },
    {
        path: '/leads',
        component: Leads.Index,
        name: 'leads.index',
        meta: { template: 'chameleon', requiresAuth: true, can: 'read leads' }
    },
    {
        path: '/leads/:lead_id',
        component: Leads.Show,
        name: 'leads.show',
        meta: { template: 'chameleon', requiresAuth: true, can: 'read leads' },
        children: [
            {
                path: 'overview',
                component: Leads.Overview,
                name: 'leads.overview',
                meta: { template: 'chameleon', requiresAuth: true, can: 'read leads' }
            }
        ]
    },
    {
      path: '/dashboard/support',
      component: Support.Dashboard,
      name: 'dashboards.support',
      meta: { template: 'chameleon', requiresAuth: true }
    },
    {
        path: '/home',
        component: Dashboards.DefaultDashboard,
        name: 'home',
        meta: { template: 'chameleon', requiresAuth: true }
    },
    {
    	path: '/',
        component: Templates.App,
        meta: { requiresAuth: true },
        name: 'dashboard',
        children: [
            ...invoiceRoutes,
            {
                path: 'quotes',
                component: Quotes.Quotes,
                name: 'quotes.index'
            },
            {
                path: '/quotes/:quote_id',
                component: Quotes.Show,
                name: 'quotes.show',
            },
            {
                path: '/environments/:environment_id',
                component: Environments.Show,
                name: 'environments.show',
            },
            {
                path: 'sprint-reviews',
                component: SprintReviews.SprintReviews,
                name: 'sprint-reviews.index'
            },
            {
                path: '/sprint-reviews/:sprint_review_id',
                component: SprintReviews.Show,
                name: 'sprint-reviews.show'
            },
             {
             	path: 'schedule',
                 component: Schedule.Index,
                 name: 'schedule.index'
             },
             {
             	path: 'schedule/projects',
                 component: require('../components/schedule/project.vue').default,
                 name: 'schedule.projects'
             },
             {
             	path: 'schedule/unscheduled',
                 component: require('../components/schedule/unscheduled.vue').default,
                 name: 'schedule.unscheduled'
             }
        ]
    },
    {
    	path: '*',
        component: NotFound
    }
]
